import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31937ea1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31937ea1')) {
      api.createRecord('31937ea1', component.options)
    } else {
      api.reload('31937ea1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31937ea1&", function () {
      api.rerender('31937ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/taskInfo/index.vue"
export default component.exports